import * as types from '../mutation-types'

// initial state
const state = {
  loading_progress: 0
}

// getters
const getters = {
  isLoading: state => state.loading_progress < 100,
  loadingProgress: state=> state.loading_progress,
  loadingIncrement: () => { return 100 / process.env.VUE_APP_LOADING_SEGMENTS }
}

// actions
const actions = {
  resetLoadingProgress({ commit }){
    commit(types.RESET_LOADING_PROGRESS)
  },
}

// mutations
const mutations = {
  [types.INCREMENT_LOADING_PROGRESS] (state) {
    state.loading_progress = Math.min(state.loading_progress + getters.loadingIncrement(), 100)
  },

  [types.RESET_LOADING_PROGRESS] (state) {
    state.loading_progress = 0
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
